import { render } from "./FieldInput.vue?vue&type=template&id=3735917f&bindings={\"name\":\"props\",\"error\":\"props\",\"label\":\"options\"}"
import script from "./FieldInput.vue?vue&type=script&lang=js"
export * from "./FieldInput.vue?vue&type=script&lang=js"
script.render = render

export default script